const DEFAULT_PHONE_COUNTRY_CODE = '212';

const normalizePhoneDigits = (value: string | null | undefined): string => {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const hasExplicitIntl = raw.startsWith('+') || raw.startsWith('00');
  let digits = raw.replace(/\D/g, '');
  if (digits.length < 8) return '';
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (hasExplicitIntl) return digits;
  if (digits.startsWith(DEFAULT_PHONE_COUNTRY_CODE) && digits.length >= DEFAULT_PHONE_COUNTRY_CODE.length + 8) {
    return digits;
  }
  if (!digits.startsWith('0') && digits.length >= 11) return digits;
  if (digits.startsWith('0')) digits = digits.slice(1);
  return DEFAULT_PHONE_COUNTRY_CODE + digits;
};

const MOBILE_LOCAL_RE = /^[67]\d{8}$/;

const extractMobileLocal = (value: string | null | undefined): string | null => {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return null;
  if (MOBILE_LOCAL_RE.test(digits)) return digits;
  if (/^0[67]\d{8}$/.test(digits)) return digits.slice(1);
  if (/^212[67]\d{8}$/.test(digits)) return digits.slice(3);
  if (/^33[67]\d{8}$/.test(digits)) return digits.slice(2);
  return null;
};

const addMobileCrossCountryVariants = (variants: Set<string>, value: string | null | undefined) => {
  const local = extractMobileLocal(value);
  if (!local) return;
  variants.add(local);
  variants.add(`0${local}`);
  variants.add(`212${local}`);
  variants.add(`33${local}`);
};

export const phoneMatchVariants = (value: string | null | undefined): string[] => {
  const digits = normalizePhoneDigits(value);
  if (!digits) return [];
  const rawDigits = String(value || '').replace(/\D/g, '');
  const variants = new Set([digits, rawDigits].filter(Boolean));

  addMobileCrossCountryVariants(variants, digits);
  if (rawDigits !== digits) {
    addMobileCrossCountryVariants(variants, rawDigits);
  }

  if (!extractMobileLocal(digits) && !extractMobileLocal(rawDigits)) {
    if (digits.startsWith('212') && digits.length >= 11) {
      variants.add(digits.slice(3));
      variants.add(`0${digits.slice(3)}`);
    }
    if (digits.startsWith('33') && digits.length >= 11) {
      variants.add(digits.slice(2));
      variants.add(`0${digits.slice(2)}`);
    }
    if (digits.startsWith('0') && digits.length >= 9) {
      variants.add(`212${digits.slice(1)}`);
      variants.add(`33${digits.slice(1)}`);
    }
  }
  return Array.from(variants);
};

export const phonesMatch = (a: string | null | undefined, b: string | null | undefined): boolean => {
  if (!a || !b) return false;
  const left = new Set(phoneMatchVariants(a));
  return phoneMatchVariants(b).some((variant) => left.has(variant));
};
